import * as React from 'react';
import './ErrorUI.css';

export default class ErrorUI extends React.Component {
  constructor(props: any) {
    super(props);
  }

  public render(){
    return(
      <div id="ErrorUI">
          <h4>Oups...</h4>
          <p>Une erreur est survenue, veuillez rafraîchir la page.</p>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ErrorUI/ErrorUI.tsx